import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontally24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconFlipHorizontally24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m7.236 18.481 10-1.563a1.5 1.5 0 0 0 1.268-1.482v-.935h1.5v.935a3 3 0 0 1-2.537 2.964l-10 1.563A3 3 0 0 1 4.004 17v-2.498h1.5V17a1.5 1.5 0 0 0 1.732 1.482M20.004 9.5h-1.5v-.935a1.5 1.5 0 0 0-1.268-1.482l-10-1.563A1.5 1.5 0 0 0 5.504 7v2.498h-1.5V7a3 3 0 0 1 3.463-2.964l10 1.563a3 3 0 0 1 2.537 2.964zm1.246 3.251a.75.75 0 0 0 0-1.5H2.754a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontally24);
